import React from "react";
import "./GeospatialSection.css";

const GeospatialSection = () => {
  const geospatialItems = [];

  return (
    <section className="geospatial-section">
      <div className="geospatial-container">
        {geospatialItems.map((item, index) => (
          <div
            key={item.id}
            className={`geospatial-row ${
              index % 2 === 0 ? "left-align" : "right-align"
            }`}
          >
            <div className="geospatial-content">
              <div className="geospatial-icon">
                <span className="icon-emoji">{item.icon}</span>
              </div>
              <h3 className="geospatial-title">{item.title}</h3>
              <p className="geospatial-description">{item.description}</p>
            </div>
            <div className="geospatial-visual">
              <div className="geospatial-placeholder">
                <div className="placeholder-content">
                  <span className="placeholder-icon">{item.icon}</span>
                  <p>Interactive Demo</p>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* <div className="military-stats">
          <div className="stat-item">
            <div className="stat-number">75%</div>
            <div className="stat-label">Planning Cycle Reduction</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">24/7</div>
            <div className="stat-label">Mission Support</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">100%</div>
            <div className="stat-label">Operational Readiness</div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default GeospatialSection;
